<template>
	<div class="page">
		<div class="nucleustit">
			<div class="tit">活体销售排名</div>
			<div>
				<el-button type="warning" @click="$router.back()" size="mini">返回</el-button>
			</div>
		</div>
		<div class="con">
			<div class="panel1">
				<div class="tabLine">
					<div class="tabItem" :class="[tabIndex===0?'active':'']" @click="changeTabIndex(0)">活体性别排名</div>
					<div class="tabItem" :class="[tabIndex===1?'active':'']" @click="changeTabIndex(1)">活体品种排名</div>
					<div class="tabItem" :class="[tabIndex===2?'active':'']" @click="changeTabIndex(2)">活体年龄排名</div>
					<div class="tabItem" :class="[tabIndex===3?'active':'']" @click="changeTabIndex(3)">活体售价排名</div>
				</div>
				<div class="search">
					门店：
					<el-select style="width: 100px;margin-right:20px;" v-model="shopId1" placeholder="请选择" size='mini' @change="getTopData">
						<el-option v-for="item in [{shop_name:'全部',shop_id:''}].concat(shopList)" :key='item.shop_id' :label="item.shop_name" :value="item.shop_id">
						</el-option>
					</el-select>
					日期：
					<el-date-picker v-model="curDate1" @change="getTopData" :clearable="false" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" size="mini" style="width:220px;">
					</el-date-picker>
				</div>
			</div>
			<div class="panel2">
				<div v-if="tabIndex===0" style="display: flex;padding:20px 0;">
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">公猫销售数量最高</div>
							<div class="panel3Cell2" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.maleCatHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.maleCatHighestCount?sexTopObj.maleCatHighestCount.count:0}}只/{{sexTopObj.maleCatHighestCount?sexTopObj.maleCatHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group1.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">母猫销售数量最高</div>
							<div class="panel3Cell2" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.femaleCatHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.femaleCatHighestCount?sexTopObj.femaleCatHighestCount.count:0}}只/{{sexTopObj.femaleCatHighestCount?sexTopObj.femaleCatHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group2.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">公犬销售数量最高</div>
							<div class="panel3Cell2" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.maleDogHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.maleDogHighestCount?sexTopObj.maleDogHighestCount.count:0}}只/{{sexTopObj.maleDogHighestCount?sexTopObj.maleDogHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group3.png">
					</div>
					<div class="panel3Cell" style="margin:0">
						<div class="panel3CellL">
							<div class="panel3Cell1">母犬销售数量最高</div>
							<div class="panel3Cell2" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.femaleDogHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="sexTopObj.maleCatHighestCount">{{sexTopObj.femaleDogHighestCount?sexTopObj.femaleDogHighestCount.count:0}}只/{{sexTopObj.femaleDogHighestCount?sexTopObj.femaleDogHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group4.png">
					</div>
				</div>
				<div v-if="tabIndex===1" style="display: flex;padding:20px 0;">
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫品种销售数量最高</div>
							<div class="panel3Cell2" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.catHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.catHighestCount?categoryTopObj.catHighestCount.count:0}}只/{{categoryTopObj.catHighestCount?categoryTopObj.catHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group1.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬品种售数量最高</div>
							<div class="panel3Cell2" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.dogHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.dogHighestCount?categoryTopObj.dogHighestCount.count:0}}只/{{categoryTopObj.dogHighestCount?categoryTopObj.dogHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group2.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫品种销售金额最高</div>
							<div class="panel3Cell2" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.catHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.catHighestAmount?categoryTopObj.catHighestAmount.count:0}}只/{{categoryTopObj.catHighestAmount?categoryTopObj.catHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group3.png">
					</div>
					<div class="panel3Cell" style="margin:0">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬品种售金额最高</div>
							<div class="panel3Cell2" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.dogHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="categoryTopObj.catHighestCount">{{categoryTopObj.dogHighestAmount?categoryTopObj.dogHighestAmount.count:0}}只/{{categoryTopObj.dogHighestAmount?categoryTopObj.dogHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group4.png">
					</div>
				</div>
				<div v-if="tabIndex===2" style="display: flex;padding:20px 0;">
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫年龄销售数量最高</div>
							<div class="panel3Cell2" v-if="ageTopObj.catHighestCount">{{ageTopObj.catHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="ageTopObj.catHighestCount">{{ageTopObj.catHighestCount?ageTopObj.catHighestCount.count:0}}只/{{ageTopObj.catHighestCount?ageTopObj.catHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group1.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬年龄销售数量最高</div>
							<div class="panel3Cell2" v-if="ageTopObj.catHighestCount">{{ageTopObj.dogHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="ageTopObj.catHighestCount">{{ageTopObj.dogHighestCount?ageTopObj.dogHighestCount.count:0}}只/{{ageTopObj.dogHighestCount?ageTopObj.dogHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group2.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫年龄销售金额最高</div>
							<div class="panel3Cell2" v-if="ageTopObj.catHighestCount">{{ageTopObj.catHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="ageTopObj.catHighestCount">{{ageTopObj.catHighestAmount?ageTopObj.catHighestAmount.count:0}}只/{{ageTopObj.catHighestAmount?ageTopObj.catHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group3.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬年龄销售金额最高</div>
							<div class="panel3Cell2" v-if="ageTopObj.catHighestCount">{{ageTopObj.dogHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="ageTopObj.catHighestCount">{{ageTopObj.dogHighestAmount?ageTopObj.dogHighestAmount.count:0}}只/{{ageTopObj.dogHighestAmount?ageTopObj.dogHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group4.png">
					</div>
				</div>
				<div v-if="tabIndex===3" style="display: flex;padding:20px 0;">
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫星级价格销售数量最高</div>
							<div class="panel3Cell2" v-if="priceTopObj.catHighestCount">{{priceTopObj.catHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="priceTopObj.catHighestCount">{{priceTopObj.catHighestCount?priceTopObj.catHighestCount.count:0}}只/{{priceTopObj.catHighestCount?priceTopObj.catHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group1.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬星级价格销售数量最高</div>
							<div class="panel3Cell2" v-if="priceTopObj.catHighestCount">{{priceTopObj.dogHighestCount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="priceTopObj.catHighestCount">{{priceTopObj.dogHighestCount?priceTopObj.dogHighestCount.count:0}}只/{{priceTopObj.dogHighestCount?priceTopObj.dogHighestCount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group2.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">猫星级价格销售金额最高</div>
							<div class="panel3Cell2" v-if="priceTopObj.catHighestCount">{{priceTopObj.catHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="priceTopObj.catHighestCount">{{priceTopObj.catHighestAmount?priceTopObj.catHighestAmount.count:0}}只/{{priceTopObj.catHighestAmount?priceTopObj.catHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group3.png">
					</div>
					<div class="panel3Cell">
						<div class="panel3CellL">
							<div class="panel3Cell1">犬星级价格销售金额最高</div>
							<div class="panel3Cell2" v-if="priceTopObj.catHighestCount">{{priceTopObj.dogHighestAmount.info||'-'}}</div>
							<div class="panel3Cell3" v-if="priceTopObj.catHighestCount">{{priceTopObj.dogHighestAmount?priceTopObj.dogHighestAmount.count:0}}只/{{priceTopObj.dogHighestAmount?priceTopObj.dogHighestAmount.amount:0}}元</div>
						</div>
						<img class="panel3CellR" src="../../../assets/img/shuju/Group4.png">
					</div>
				</div>
			</div>
			<div class="panel3">
				<div style="padding:20px 0;font-size: 14px;">
					<el-input style="width:130px;margin-right: 3px;" placeholder="请输入关键字" v-model="keyword" clearable @keyup.enter.native="changeTableData" size="mini"></el-input>
					<el-button @click="changeTableData" type="warning" size="mini">搜索</el-button>
					
					<span style="padding-left:10px;">门店:</span>
					<el-select style="width: 100px;" v-model="shopId" placeholder="请选择" size='mini' @change="changeTableData">
						<el-option v-for="item in [{shop_name:'全部',shop_id:''}].concat(shopList)" :key='item.shop_id' :label="item.shop_name" :value="item.shop_id">
						</el-option>
					</el-select>
					
					<span v-if="tabIndex===3" style="padding-left:10px;">售价区间：</span>
					<el-input v-if="tabIndex===3" v-model="minPrice" @input="changeTableData" style="width:80px;" size="mini"></el-input>
					<span v-if="tabIndex===3">-</span>
					<el-input v-if="tabIndex===3" v-model="maxPrice" @input="changeTableData" style="width:80px;" size="mini"></el-input>
					
					<span v-if="tabIndex===2" style="padding-left:10px;">宠物年龄:</span>
					<el-select v-if="tabIndex===2" style="width: 150px;" v-model="age" placeholder="请选择" size='mini' @change="changeTableData">
						<el-option v-for="item in [{label:'全部',value:''},{label:'0~3个月',value:'1'},{label:'3~6个月',value:'2'},{label:'6~9个月',value:'3'},{label:'9~12个月',value:'4'},{label:'大于12个月',value:'5'}]" :key='item.value' :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					
					<span v-if="tabIndex===0" style="padding-left:10px;">宠物性别:</span>
					<el-select v-if="tabIndex===0" style="width: 100px;" v-model="sex" placeholder="请选择" size='mini' @change="changeTableData">
						<el-option v-for="item in [{label:'全部',value:''},{label:'公',value:'公'},{label:'母',value:'母'}]" :key='item.value' :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					
					<span style="padding-left:10px;">宠物种类:</span>
					<el-select style="width: 90px;" v-model="petType" placeholder="请选择" size='mini' @change="changeTableData">
						<el-option v-for="item in [{label:'全部',value:''},{label:'猫',value:'1'},{label:'犬',value:'2'}]" :key='item.value' :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<span style="padding-left:10px;">排序:</span>
					<el-select v-model="order" placeholder="请选择" style="width: 120px;" @change="changeTableData" size="mini">
						<el-option v-for="item in [{label:'数量排名',value:'0'},{label:'按金额排序',value:'1'}]" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<span style="padding-left:10px;">日期:</span>
					<el-date-picker v-model="pickerValue" type="daterange" @change="changeTableData" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="mini" style="width: 200px;" :clearable="false">
					</el-date-picker>
					<el-button type="warning" size="mini" @click="reset" style="margin-left:10px;">重置</el-button>
					<el-button type="warning" size="mini" @click="exportExcel" style="margin-left:10px;">导出</el-button>
				</div>
				<el-table :data="tableData" style="width: 100%;">
					<el-table-column prop="no" label="排名" >
						<template slot-scope="scope">
							{{scope.row.xh}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="分类" >
						<template slot-scope="scope">
							{{scope.row.applyTypeName}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="品种" >
						<template slot-scope="scope">
							{{scope.row.category}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="年龄" v-if="tabIndex===2" :row-key="'tabIndex2'">
						<template slot-scope="scope">
							{{scope.row.age}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="性别" v-if="tabIndex===0" :row-key="'tabIndex0'">
						<template slot-scope="scope">
							{{scope.row.sex}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="售价" v-if="tabIndex===3" :row-key="'tabIndex3'">
						<template slot-scope="scope">
							{{scope.row.price}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="总计数量" >
						<template slot-scope="scope">
							{{scope.row.count}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="毛色/数量" >
						<template slot-scope="scope">
							<div v-for="(colorItem,colorIndex) in scope.row.colorInfos" :key="colorIndex">{{colorItem.color+'：'+colorItem.count}}只</div>
						</template>
					</el-table-column>
					<el-table-column prop="no" label="金额" >
						<template slot-scope="scope">
							{{scope.row.amount}}
						</template>
					</el-table-column>
					<el-table-column prop="no" label="操作" >
						<template slot-scope="scope">
							<el-button type="text" @click="toOrderList(scope.row)">查看订单</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div style="background-color: #fff;padding-top:10px;">
					<page :total="page.total" :page="page.page" @change="changePage" style="padding-bottom: 10px;"></page>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import page from "../../../components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				// tit
				tabIndex:0,
				shopId1: '',
				curDate1: [],
				sexTopObj:{},
				categoryTopObj:{},
				ageTopObj:{},
				priceTopObj:{},
				// panel3
				shopId: "",
				keyword: "",
				minPrice:'',
				maxPrice:'',
				sex: "",
				age:'',
				petType: "",
				pickerValue:[],
				order: "1",  // 0:数量排名 1:按金额排序
				page:{
					pageIndex:1,
					pageSize:10,
					total:0
				},
				tableData:[],
			}
		},
		computed:{
		},
		created() {
			this.shopList = this.$store.getters['shopList'];
			let now = new Date()
			let year = now.getFullYear()
			let month = now.getMonth()+1
			if(month<10){
				month = "0"+month
			}
			this.curDate1 = [new Date(year+'-'+month+'-01'),now];
			// panel3
			this.pickerValue = [new Date(year+'-'+month+'-01'),now]
			
			
			this.changeTabIndex(0)
		},
		mounted() {
			
		},
		methods: {
			// tit
			changeTabIndex(i){
				this.tabIndex=i;
				this.getTopData()
				this.getTableData()
			},
			toOrderList(row){
				sessionStorage.setItem("huotiStatisticsOrderList",JSON.stringify(row.orders))
				this.$router.push({path:'/huotishuju/huotiDetail'})
			},
			getTopData(){
				if(this.tabIndex===0){
					let params = {
						startTime:this.$public.FTimeStr10(this.curDate1[0]), //
						endTime:this.$public.FTimeStr10(this.curDate1[1]),  //
						shopId:this.shopId1,  
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/sex/top/data', params).then(res => {
						loading.close()
						this.sexTopObj = res.data;
					})
				}else if(this.tabIndex===1){
					let params = {
						startTime:this.$public.FTimeStr10(this.curDate1[0]), //
						endTime:this.$public.FTimeStr10(this.curDate1[1]),  //
						shopId:this.shopId1,  
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/category/top/data', params).then(res => {
						loading.close()
						this.categoryTopObj = res.data;
					})
				}else if(this.tabIndex===2){
					let params = {
						startTime:this.$public.FTimeStr10(this.curDate1[0]), //
						endTime:this.$public.FTimeStr10(this.curDate1[1]),  //
						shopId:this.shopId1,  
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/age/top/data', params).then(res => {
						loading.close()
						this.ageTopObj = res.data;
					})
				}else if(this.tabIndex===3){
					let params = {
						startTime:this.$public.FTimeStr10(this.curDate1[0]), //
						endTime:this.$public.FTimeStr10(this.curDate1[1]),  //
						shopId:this.shopId1,  
					}
					let loading = this.$loading()
					this.$http.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/price/top/data', params).then(res => {
						loading.close()
						this.priceTopObj = res.data;
					})
				}
			},
			changeTableData(){
				this.page.pageIndex = 1
				this.getTableData()
			},
			changePage(num){
				this.page.pageIndex = num
				this.getTableData()
			},
			reset(){
				this.shopId = ''
				this.keyword = ''
				this.sex = ''
				this.age = ''
				this.minPrice = ''
				this.maxPrice = ''
				this.petType = ''
				this.order = '1'
				this.page.pageIndex = 1
				this.getTableData()
			},
			exportExcel(){
				if(this.tabIndex===0){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"sex": this.sex,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					axios.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/sex/list/export', {
						params:params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '按性别导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					})
				}else if(this.tabIndex===1){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					axios.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/category/list/export', {
						params:params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '按品种导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					})
				}else if(this.tabIndex===2){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"age": this.age,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					axios.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/age/list/export', {
						params:params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '按年龄导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					})
				}else if(this.tabIndex===3){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"petType": this.petType,
						"minPrice": Number(this.minPrice),
						"maxPrice": Number(this.maxPrice),
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					axios.get(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/price/list/export', {
						params:params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '按售价导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					})
				}
			},
			getTableData(){
				if(this.tabIndex===0){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"pageIndex": this.page.pageIndex,
						"pageSize": this.page.pageSize,
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"sex": this.sex,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/sex/list', params).then(res => {
						loading.close()
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					})
				}else if(this.tabIndex===1){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"pageIndex": this.page.pageIndex,
						"pageSize": this.page.pageSize,
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/category/list', params).then(res => {
						loading.close()
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					})
				}else if(this.tabIndex===2){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"pageIndex": this.page.pageIndex,
						"pageSize": this.page.pageSize,
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"age": this.age,
						"petType": this.petType,
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/age/list', params).then(res => {
						loading.close()
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					})
				}else if(this.tabIndex===3){
					let startTime = ''
					let endTime = ''
					if(this.pickerValue.length===2){
						startTime = this.$public.FTimeStr10(this.pickerValue[0])
						endTime = this.$public.FTimeStr10(this.pickerValue[1]) 
					}else{
						this.$message({
							message: '日期选择有误',
							type: 'error'
						});
						return ;
					}
					let params = {
						"pageIndex": this.page.pageIndex,
						"pageSize": this.page.pageSize,
						"shopId": this.shopId,
						"keyWord": this.keyword,
						"petType": this.petType,
						"minPrice": Number(this.minPrice),
						"maxPrice": Number(this.maxPrice),
						startTime:startTime, //
						endTime:endTime,  //
						"order": this.order,  // 0:数量排名 1:按金额排序
					}
					let loading = this.$loading()
					this.$http.post(process.env.VUE_APP_Url9+'api/Statistics/pet/sale/price/list', params).then(res => {
						loading.close()
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					})
				}
			},
		},
	}
</script>
<style scoped lang="scss">
	.page {
		width:100%;
		.nucleustit {
			display: flex;justify-content: space-between;height: 57px;box-sizing: border-box;padding:16px 16px 0 16px;background-color: #fff;
			.tit {
				color: $fontColor;font-size: 18px;font-weight: bold;margin:4px 0;padding:0 6px;box-sizing: border-box;height: 20px;line-height: 20px;
			}
		}
		.con{
			background-color: #fff;border-radius: 10px;width:100%;padding:20px;box-sizing: border-box;margin-top:12px;
			.panel1{
				height: 64px;border-bottom: 1px solid #F1F3F9;display: flex;justify-content: space-between;
				.tabLine{
					display: flex;
					.tabItem{
						font-size: 16px;color:$fontColor;margin:0 35px;border-bottom:2px solid transparent;padding:20px 0 26px;cursor: pointer;
						&.active{
							color:$mainColor;border-color:$mainColor;
						}
					}
				}
				.search{
					padding:20px 0 26px;
				}
			}
			.panel2{
				.panel3Cell{
					width:100%;height: 168px;margin-right: 12px;border:1px solid #EAEDF7;box-shadow: 0px 2px 4px 0px rgba(28, 41, 90, 0.04);border-radius: 10px;padding:20px;box-sizing: border-box;position: relative;
					.panel3CellL{
						display: inline-block;
						.panel3Cell1{
							font-size: 16px;color:#666;padding-top:15px;
						}
						.panel3Cell2{
							font-size: 24px;color:#242F57;padding:15px 0;
						}
						.panel3Cell3{
							font-size: 16px;color:#333;
						}
					}
					.panel3CellR{
						width:113px;display: inline-block;vertical-align:sub;position: absolute;top: 20px;right: 20px;
					}
				}
			}
			.panel3{
				padding-top:10px;
			}
		}
	}
</style>
